import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import * as React from "react";
import { css } from "styled-components";

type Props = OwnProps;

const enum fields {
    padding = "padding",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.padding]: string;
    };
}

const ContentSpacer: React.FC<Props> = ({ fields }) => {
    const contentSpacerStyle = {
        css: css`
            height: 1px;
            width: 100%;
            padding-top: ${fields.padding}px;
            padding-bottom: ${fields.padding}px;
            background: transparent;
        `,
    };
    return <StyledWrapper {...contentSpacerStyle}></StyledWrapper>;
};

const widgetModule: WidgetModule = {
    component: ContentSpacer,
    definition: {
        group: "Basic",
        fieldDefinitions: [
            {
                name: fields.padding,
                editorTemplate: "IntegerField",
                defaultValue: 10,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
